export const APPLICATION_NAME = 'found-faq'
